// extracted by mini-css-extract-plugin
module.exports = {"list":"AppSidebarLinks_list_3vnIB","parent":"AppSidebarLinks_parent_1g50q"};